export default __webpack_public_path__ + "static/media/above-the-fold-bg.77be4023.jpg";